<template>
  <VCard class="cabinet-card mb-5">
    <div class="relative">
      <VBtn
        icon
        small
        absolute
        top
        right
        @click="hide"
        class="btn-close"
      >
        <IconClose />
      </VBtn>
    </div>
    <div v-if="company.companyPartnerCode === companyPartnerCodeTypes.ROSTELECOM" class="cabinet-card-title">
      <img src="../../assets/img/rt/huntica-rt.svg" alt="">
      <div>Huntica теперь часть экосистемы Ростелеком</div>
    </div>
    <VRow class="align-stretch">
      <VCol cols="12" lg="6">
        <div class="cabinet-left d-flex justify-space-between flex-column">
          <div>
            <VCardTitle class="cabinet-title align-start">
              <VIcon
                v-if="company.settings.companyAboutFilled"
                class="cabinet-icon action-done mt-1"
                color="success"
              >
                mdi-check
              </VIcon>
              <span class="count-title">
                {{ $t('fill') }}
                <RouterLink :to="{ name: 'company' }" class="cabinet-link">
                  {{ $t('companyInfo') }}
                </RouterLink>
              </span>
            </VCardTitle>
            <VCardText>
              <div class="cabinet-text">
                {{ $t('addInfoTip') }}
              </div>
            </VCardText>
            <VCardTitle class="cabinet-title align-start">
              <VIcon
                v-if="company.settings.vacanciesAdded"
                class="cabinet-icon action-done mt-1"
                color="success"
              >
                mdi-check
              </VIcon>
              <span class="count-title">
                <VacancyStoreButton
                  link
                  class="cabinet-link"
                >
                  {{ $t('addVacancies') }}
                </VacancyStoreButton>
              </span>
            </VCardTitle>
            <VCardText>
              <div class="cabinet-text">
                {{ $t('addDescription') }}
              </div>
            </VCardText>
            <template v-if="showExtensionTip">
              <VCardTitle class="cabinet-title">
                <VIcon v-if="hasExtension" class="cabinet-icon action-done mt-1" color="success">
                  mdi-check
                </VIcon>
                <span class="count-title">
                  {{ $t('install') }}
                  <a
                    :href="chromeExtensionURL"
                    target="_blank"
                    class="cabinet-link"
                  >{{ $t('chromeExtension') }}</a>
                </span>
              </VCardTitle>
              <VCardText>
                <div class="cabinet-text">
                  {{ $t('extensionDescription') }}
                </div>
              </VCardText>
            </template>
            <template>
              <VCardTitle class="cabinet-title align-start">
                <VIcon
                  v-if="company.settings.candidatesInvited"
                  class="cabinet-icon action-done mt-1"
                  color="success"
                >
                  mdi-check
                </VIcon>
                <span class="count-title">{{ $t('sendInvitation') }}
                </span>
              </VCardTitle>
              <VCardText>
                <div class="cabinet-text">
                  {{ $t('extensionTip') }}
                </div>
              </VCardText>
            </template>

            <VCardTitle class="cabinet-title">
              <VIcon
                v-if="company.settings.interviewsViewed"
                class="cabinet-icon action-done"
                color="success"
              >
                mdi-check
              </VIcon>
              <span class="count-title">
                {{ $t('watchInterview') }}
              </span>
            </VCardTitle>
            <VCardText>
              <div class="cabinet-text">
                {{ $t('watchInterviews') }}
              </div>
            </VCardText>

            <VCardTitle class="cabinet-title">
              <VIcon
                v-if="users.length > 1"
                class="cabinet-icon action-done"
                color="success"
              >
                mdi-check
              </VIcon>
              <span class="count-title">
                {{ $t('addOtherUsers') }}
              </span>
            </VCardTitle>
            <VCardText>
              <div class="cabinet-text">
                {{ $t('addOtherUsersDescription') }}
              </div>
            </VCardText>
          </div>

          <VCheckbox
            v-model="neverShowDashboardTip"
            :label="$t('notAgainPlease')"
            style="font-size: 0.75rem"
            class="cabinet-input"
          />
        </div>
      </VCol>
      <VCol
        cols="12"
        lg="6"
        xs5
        d-flex
        justify-content-between
      >
        <div class="cabinet-right">
          <VRow class="justify-space-between h-100" style="height: 100%">
            <VCol
              cols="12"
              sm="6"
              lg="12"
              class="py-lg-0"
            >
              <VCardTitle class="cabinet-contact">
                {{ $t('careerPortal') }}
              </VCardTitle>
              <VCardText class="mt-2 mb-4">
                {{ $t('uniqueFeatures') }}
              </VCardText>
              <RouterLink
                class="button-trial ml-4"
                :to="{ name: 'career-portal' }"
              >
                {{ $t('more') }}
              </RouterLink>
            </VCol>
            <VCol>
              <VImg v-if="locale === 'ru'" :src="require('@/assets/img/laptop-template-ru.png')" style="max-width: 280px; margin: 0 auto;" />
              <VImg v-else :src="require('@/assets/img/laptop-template-en.png')" style="max-width: 280px; margin: 0 auto;" />
              <div class="cabinet-right__available">
                {{ $t('availablePortal') }}
              </div>
            </VCol>
            <VCol cols="12" sm="6" lg="12">
              <div class="cabinet-right__bottom">
                <VCardTitle class="cabinet-contact">
                  {{ $t('loyaltyProgram') }}
                </VCardTitle>
                <VCardText class="my-3">
                  <div>{{ $t('loyaltyProgramSubtitle1') }}</div>
                  <div>{{ $t('loyaltyProgramSubtitle2', { percent: company.referralDiscountPercent }) }}</div>
                </VCardText>
                <RouterLink
                  class="button-trial ml-4"
                  :to="{ name: 'settings',
                         params: { type: settingsTabs.PAYMENT, addType: paymentTabs.LOYALTY } }"
                >
                  {{ $t('more') }}
                </RouterLink>
              </div>
            </VCol>
          </VRow>
        </div>
      </VCol>
    </VRow>
  </VCard>
</template>

<script>
import {
  chromeExtensionMessageTypes, companyPartnerCodeType, localeType, settingsTabs, paymentTabs,
} from '@/enums';
import { useI18n } from 'vue-i18n-composable';
import VacancyStoreButton from '../Vacancy/VacancyStoreButton.vue';
import IconClose from '../SvgIcons/Close.vue';
import CompanySettings from '../../orm/models/Company/Settings';

export default {
  name: 'DashboardCard',
  components: {
    VacancyStoreButton,
    IconClose,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { locale } = useI18n();

    return {
      locale: locale.value.toLowerCase(),
      settingsTabs,
      paymentTabs,
    };
  },
  data() {
    return {
      chromeExtensionURL: process.env.VUE_APP_CHROME_EXTENSION_URL,
      neverShowDashboardTip: false,
      hasExtension: false,
      companyPartnerCodeTypes: companyPartnerCodeType,
    };
  },
  computed: {
    showExtensionTip() {
      // return this.$i18n.locale !== localeType.EN;
      return false;
    },
  },
  watch: {
    neverShowDashboardTip(val) {
      CompanySettings.api().update(this.company.id, { showDashboardTip: !val });
    },
  },
  created() {
    if (!window.chrome || !window.chrome.runtime || !process.env.VUE_APP_CHROME_EXTENSION_ID) {
      return;
    }

    window.chrome.runtime.sendMessage(
      process.env.VUE_APP_CHROME_EXTENSION_ID,
      { type: chromeExtensionMessageTypes.GET_VERSION },
      (reply) => {
        if (reply && reply.data && reply.data.version) {
          this.hasExtension = true;
        }
      },
    );
  },
  methods: {
    hide() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .cabinet-card.v-card {
    background: #FFFFFF;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    padding: 0;
    .btn-close {
      z-index: 2;
    }
  }
  .cabinet-card-title {
    padding: 0.875rem 1.25rem 2px 2rem;
    font-size: 0.875rem;
    color: #212121;
    img {
      max-width: 100%;
    }
  }
  .cabinet-left {
    padding-left: 27px;
    height: 100%;
  }
  .cabinet-title.v-card__title {
    padding: 12px 16px 2px 37px;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
  }
  .cabinet-link {
    text-decoration: underline;
    text-decoration-color: #0a82d9;
  }
  .cabinet-contact {
    font-size: 1.125rem;
    line-height: 1.33;
    padding-bottom: 2px;
    padding-top: 10px;
  }
  .cabinet-text {
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.7;
    padding-left: 21px;
  }
  .v-card__title + .v-card__text {
    padding-bottom: 0;
  }
  .count-title {
    &:before {
      content: attr(data-count);
    }
  }
  .cabinet-icon.action-done.v-icon {
    left: 30px;
    line-height: 0.7;
    position: absolute;
  }
  .cabinet-input {
    font-size: 0.75rem;
    padding-top: 22px;
    label.v-label {
      font-size: 0.75rem;
    }
  }
  .cabinet-right {
    height: 100%;
    position: relative;
    padding: 2px 0 6px 15px;
    &:before {
      content: '';
      position: absolute;
      width: 1px;
      background: #eeeeee;
      left: 0;
      top: -12px;
      bottom: -12px;
    }
    &__available {
      margin: 20px auto 0;
      max-width: 297px;
      font-weight: 300;
      font-size: 12px;
      line-height: 120%;
      text-align: center;
      color: #212121;
      opacity: 0.4;
    }
    &__bottom {
      padding-bottom: 5px;
      &:before {
        content: '';
        position: absolute;
        height: 1px;
        background-color: #eeeeee;
        width: 100%;
        left: 0;
      }
    }
    .v-card__text::v-deep {
      font-weight: 300;
      font-size: 14px;
      line-height: 22px;
      color: #212121
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .cabinet-card-title {
      padding: 1.375rem 1.75rem 0 2.25rem;
      line-height: 1.33;
    }
    .cabinet-right {
      height: 100%;
      position: relative;
      padding-left: 15px;
      padding-top: 2px;
      &:before {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        background: #eeeeee;
        left: 0;
        top: 0;
        bottom: inherit;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .cabinet-left {
      padding-left: 24px;
    }
    .cabinet-icon.action-done.v-icon {
      font-size: 1.25rem;
      left: 14px;
      line-height: 0.7;
    }
    .cabinet-title.v-card__title {
      font-size: 1rem;
      line-height: 1.2;
      padding: 8px 26px 3px 12px;
    }
    .cabinet-contact {
      font-size: 1rem;
      line-height: 1.33;
      padding-bottom: 2px;
      padding-top: 10px;
    }
    .cabinet-text {
      line-height: 1.4;
      padding: 0 26px 10px 0;
    }
    .btn-close {
      top: 5px;
      right: 5px;
    }
    .cabinet-input {
      padding-top: 8px;
    }
    .cabinet-right {
      height: 100%;
      position: relative;
      padding: 0 0 6px 4px;
    }
  }
</style>

<i18n locale="en" lang="yaml">
  fill: Complete
  companyInfo: company information
  addInfoTip: Add information about the company for candidates' reference
  addVacancies: Add jobs
  addDescription: Add a position description and create a list of virtual interview questions
  install: Install
  chromeExtension: Google Chrome extension
  extensionDescription: Convenient tool for inviting candidates for online interview
  sendInvitation: Send an invitation to the candidates
  # extensionTip: You can use the Google Chrome extension - convenient tool to invite candidates.
  extensionTip: You can post a link to a virtual interview on social networks or the internet
  watchInterview: Watch interviews
  watchInterviews: Watch interviews of candidates and choose the best one!
  notAgainPlease: Don't show me again
  payment: Payments
  tariff: Your plan
  careerPortal: Career portal
  uniqueFeatures: "Create a landing page for your company with job openings and a blog directly on Huntica.
  No specialized knowledge is required – all you have to do is choose a template, adapt it to your needs,
   and link the domain following the step-by-step instructions on the site."
  more: More
  availablePortal: The career portal is available on the «Standard» tariff and above.
  addOtherUsers: Add other users
  addOtherUsersDescription: Add other users to collectively utilize all the unique features of Huntica
  loyaltyProgram: Loyalty program
  loyaltyProgramSubtitle1: Share the Huntica referral link and get rewarded for each paid tariff.
  loyaltyProgramSubtitle2: 'Anyone who uses your referral link will also receive a {percent}% discount on their first payment for any tariff plan.'
</i18n>

<i18n locale="ru" lang="yaml">
  fill: Заполните
  companyInfo: информацию о компании
  addInfoTip: Добавьте информацию о компании, чтобы кандидаты понимали, кто их приглашает на работу
  addVacancies: Добавляйте вакансии
  addDescription: Добавьте описание и составьте список вопросов для интервью
  install: Установите
  chromeExtension: расширение Google Chrome
  extensionDescription: >-
    Удобный инструмент для приглашения кандидатов на виртуальное интервью с HH.ru
  sendInvitation: Отправьте приглашения кандидатам
  extensionTip: |-
    Вы можете сделать это через расширение для Google Chrome, либо разместить ссылку
    на виртуальное интервью в соцсетях или интернете.
  watchInterview: Смотрите интервью
  watchInterviews: Отсматривайте интервью кандидатов и выбирайте лучших!
  notAgainPlease: Больше не показывать
  payment: Оплата и работа с юридическими лицами
  tariff: Ваш тариф
  careerPortal: Карьерный портал
  uniqueFeatures: "Создайте лендинг компании с вакансиями и блогом прямо на
  Huntica. Не нужны специальные знания – достаточно выбрать
  шаблон, адаптировать его под себя и привязать домен по
  инструкции на сайте."
  more: Подробнее
  availablePortal: Карьерный портал доступен на тарифе «Стандарт» и выше.
  addOtherUsers: Добавляйте других пользователей
  addOtherUsersDescription: Добавьте других пользователей для коллективного использования всех уникальных возможностей Huntica
  loyaltyProgram: Программа лояльности
  loyaltyProgramSubtitle1: Поделитесь ссылкой на Huntica и получите вознаграждение за каждый оплаченный тариф.
  loyaltyProgramSubtitle2: 'Те, кто воспользуются вашей ссылкой реферальной, получат скидку в {percent}% на первую оплату любого тарифного плана.'
</i18n>
